import { loginActions } from '../actions'
const { CLEAR_ERROR, SET_ERROR, SET_SUCCESS_MESSAGE, SET_FAILURE_MESSAGE } = loginActions

const initialState = {
  error: null,
  successMessage: '',
  errorMessage: ''
}

const auth = (state = initialState, action = '') => {
  switch (action.type) {
    case CLEAR_ERROR:
      return {
        ...state,
        error: null
      }

    case SET_SUCCESS_MESSAGE:
      return {
        ...state,
        successMessage: action.message
      }

    case SET_FAILURE_MESSAGE:
      return {
        ...state,
        errorMessage: action.message
      }

    case SET_ERROR:
      return {
        ...state,
        error: action.error
      }

    default:
      return state
  }
}

export default auth



// WEBPACK FOOTER //
// ./src/reducers/authResponse.js